// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dzy2Ei {
  display: grid;
  grid-template-columns: repeat(var(--current-grid-columns, 12), 1fr);
  grid-template-rows: auto auto 1fr;
  grid-template-areas:
    'title title title title title title title title title action action action'
    'content content content content content content content content content content content content'
    'content content content content content content content content content content content content';
  gap: var(--spacing-3, 24px) 0;
  padding-top: var(--spacing-3, 24px);
  padding-bottom: var(--spacing-3, 24px);
  min-height: 100%;
  width: 100%;
}

.pxxPHe {
  grid-area: title;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-xl, 20px);
  margin: 0;
  display: flex;
  align-items: center;
}

.Bv3G1V {
  grid-area: action;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--spacing-2, 16px);
}

.KrQCMK {
  grid-area: content;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/InternalPageContent/InternalPageContent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mEAAmE;EACnE,iCAAiC;EACjC;;;qGAGmG;EACnG,6BAA6B;EAC7B,mCAAmC;EACnC,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iEAAiE;EACjE,6CAA6C;EAC7C,oCAAoC;EACpC,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd","sourcesContent":[".container {\n  display: grid;\n  grid-template-columns: repeat(var(--current-grid-columns, 12), 1fr);\n  grid-template-rows: auto auto 1fr;\n  grid-template-areas:\n    'title title title title title title title title title action action action'\n    'content content content content content content content content content content content content'\n    'content content content content content content content content content content content content';\n  gap: var(--spacing-3, 24px) 0;\n  padding-top: var(--spacing-3, 24px);\n  padding-bottom: var(--spacing-3, 24px);\n  min-height: 100%;\n  width: 100%;\n}\n\n.title {\n  grid-area: title;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-xl, 20px);\n  margin: 0;\n  display: flex;\n  align-items: center;\n}\n\n.action {\n  grid-area: action;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: var(--spacing-2, 16px);\n}\n\n.content {\n  grid-area: content;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Dzy2Ei`,
	"title": `pxxPHe`,
	"action": `Bv3G1V`,
	"content": `KrQCMK`
};
module.exports = ___CSS_LOADER_EXPORT___;
